import * as angular from 'angular';

export class MaterialCostsFactory {
    private apiRoot: string = '/api/v1/companies';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    create(companyId, issueId, material) {
        return this.$http.post(
            `${this.apiRoot}/${companyId}/issues/${issueId}/materialcosts/`,
            material
        );
    }

    update(companyId, issueId, materialId, material) {
        return this.$http.patch(
            `${this.apiRoot}/${companyId}/issues/${issueId}/materialcosts/${materialId}/`,
            material
        );
    }

    remove(companyId, issueId, materialId) {
        return this.$http.delete(
            `${this.apiRoot}/${companyId}/issues/${issueId}/materialcosts/${materialId}/`
        );
    }
}

angular
    .module('app')
    .service('MaterialCostsFactory', MaterialCostsFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/material-costs.factory.ts